// @ts-nocheck
export default {
	uf: {
		auxEntity: {
			entityUrl: '/process/getUf',
			tableName: 'process-dropdown-uf',
		},
		label: 'UF',
		size: 1,
		require: false,
		disabled: false,
	},
	registro: {
		label: 'Registro',
		size: 2,
		require: false,
		disabled: false,
	},
	digito: {
		auxEntity: {
			listOptions: [
				{
					id: '',
					label: '',
				},
				{
					id: 'A',
					label: 'A',
				},
				{
					id: 'B',
					label: 'B',
				},
				{
					id: 'C',
					label: 'C',
				},
				{
					id: 'D',
					label: 'D',
				},
				{
					id: 'E',
					label: 'E',
				},
				{
					id: 'F',
					label: 'F',
				},
			],
		},
		label: 'Dígito',
		size: 1,
		require: false,
		disabled: false,
	},
};
